import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom';
import config, { axiosInstance } from '../Config';
import secureLocalStorage from 'react-secure-storage';
import Loader from '../Loader';

import user_icon from "../../Assets/Images/user.webp"
import { toast } from 'react-toastify';

import swal from 'sweetalert';

const Profile = () => {

    const credential = secureLocalStorage.getItem("credentials")

    const [name, setName] = useState('')
    const [gender, setGender] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('+44-')
    const [exp_years, setexp_years] = useState('')
    const [description, setDescription] = useState('')
    const [profile_image, setProfileImage] = useState('')
    const [profile_image_link, setProfileImageLink] = useState('')
    const [website_image, setWebsiteImage] = useState('')
    const [website_image_link, setWebsiteImageLink] = useState('')
    const [location, setlocation] = useState('');
    const [oldpassword, setOldpassword] = useState('');
    const [newpassword, setnewpassword] = useState('');
    const [ShowPassword, setshowpassword] = useState(false);

    const [Certificate, setCertificate] = useState()
    const [CertificateLink, setCertificateLink] = useState()

    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useState({})

    const navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`getinstructor/${credential.id}`)
            .then(res => {
                // console.log('res', res)
                setName(res.data.instructor.name)
                setEmail(res.data.instructor.email)
                setPhone(res.data.instructor.mobile)
                setGender(res.data.instructor.gender)
                setlocation(res?.data?.instructor?.address);
                setexp_years(res?.data?.instructor?.experience)
                setDescription(res?.data?.instructor?.description)
                setProfileImageLink(res?.data?.instructor?.imageUrl)
                setWebsiteImageLink(res?.data?.instructor?.licenceimgUrl)
                setCertificateLink(res?.data?.instructor?.certificateUrl)

            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const validateForm = () => {
        const newErrors = {};

        if (!name) {
            newErrors.name = 'Name is required';
        }

        if (!gender) {
            newErrors.gender = 'gender is required';
        }

        if (!email) {
            newErrors.email = 'Email is required';
        }
        else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            newErrors.email = 'Invalid email format';
        }

        if (!phone) {
            newErrors.phone = 'Phone Number is required';
        } else if (phone.length > 15 || phone.length < 7) {
            newErrors.phone = 'Invalid Phone Number length';
        }

        if (!profile_image && !profile_image_link) {
            newErrors.profile_image = 'Profile Image is required';
        }

        if (!website_image && !website_image_link) {
            newErrors.website_image = 'Website Image is required';
        }

        if (!location) {
            newErrors.location = 'Location is required';
        }

        if (!exp_years) {
            newErrors.exp_years = 'Experience is required';
        }

        if (oldpassword && !newpassword) {
            newErrors.newpassword = "New Password is required";
        }


        if (!description) {
            newErrors.description = 'Description is required';
        }
        else if (description.split(' ').length < 100)
            newErrors.description = 'Minimum 100 words of description required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (validateForm()) {
            try {
                setLoading(true)
                const formData = new FormData()
                formData.append("name", name)
                formData.append("gender", gender)
                formData.append("email", email)
                formData.append("mobile", phone)
                formData.append("experience", exp_years)
                formData.append("description", description)
                formData.append('user_id', credential?.id)
                formData.append('address', location);
                if (profile_image) {
                    formData.append("image", profile_image)
                }
                if (website_image) {
                    formData.append("licence", website_image)
                }
                if (Certificate) {
                    formData.append("certificate", Certificate);
                }
                if (oldpassword && newpassword) {
                    formData.append("old_password", oldpassword);
                    formData.append("new_password", newpassword);
                }

                const res = await axiosInstance.post('/instructor/update', formData, {
                    headers: {
                        Authorization: `Bearer ${credential.token}`,
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",

                    }
                })

                // console.log('first', res)

                if (res.data.success == false && res.data.data == 'email already taken') {
                    toast.error('This Email already taken !');
                    setLoading(false);
                    return
                }

                if (res.data.status == "fail" && res.data.message == 'Incorrect Credentials') {
                    toast.error('Old Password is Wrong!');
                    setLoading(false);
                    return
                }

                if (res.data.success) {
                    toast.success('Profile Saved Successfully !');
                    // console.log(res.data.data[0])

                    let temp = {
                        ...credential,
                        name: res?.data?.Updated_data?.name,
                        image: res?.data?.Updated_data?.image,
                    }

                    secureLocalStorage.setItem('credentials', temp)
                    setLoading(false)
                }

                setLoading(false)


            } catch (error) {
                setLoading(false)
                if (error?.response?.data?.message == "Incorrect Credentials" && error?.response?.data?.status == "fail") {
                    toast.error('Exising Password is Incorrect!');
                } else {
                    toast.error("Something Went Wrong!")
                }
            }
        } else {
            window.scrollTo(0, 0)
        }
    };

    const allowedImg = ["image/png", "image/jpg", "image/jpeg", "image/svg+xml", "image/avif", "image/webp"]

    const handleProfileImage = (e) => {

        if (allowedImg.includes(e.target.files[0].type)) {
            setProfileImage(e.target.files[0])
            // generating image link for instant view
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfileImageLink(reader.result);
            };
            if (e.target.files[0])
                reader.readAsDataURL(e.target.files[0]);
        } else {
            swal("", "Select image only!", "warning")
        }

    }

    const handleLicenceChange = (e) => {
        if (allowedImg.includes(e.target.files[0].type)) {

            setWebsiteImage(e.target.files[0])
            const reader = new FileReader();
            reader.onloadend = () => {
                setWebsiteImageLink(reader.result);
            };
            if (e.target.files[0])
                reader.readAsDataURL(e.target.files[0]);
        } else {
            swal("", "Select image only!", "warning")
        }
    }

    const handleCertificateChange = (e) => {

        if (allowedImg.includes(e.target.files[0].type)) {
            setCertificate(e.target.files[0])
            const reader = new FileReader();
            reader.onloadend = () => {
                setCertificateLink(reader.result);
            };
            if (e.target.files[0])
                reader.readAsDataURL(e.target.files[0]);
        } else {
            swal("", "Select image only!", "warning")
        }
    }

    const handlechange = (e) => {
        const value = e.target.value;

        // Ensure the phone number starts with +44 and allow only 10 digits after that
        if (value.startsWith('+44-')) {
            // Allow up to 13 characters (including +44)
            if (value.length <= 14 && /^[0-9]*$/.test(value.substring(4))) {
                setPhone(value);
            }
        } else {
            // If the country code is removed, reset it to +44
            setPhone('+44-');
        }
    };

    return (
        <>
            {
                loading && <Loader />
            }

            <ContainerDashboard title="Your Profile" description="Everything here">
                <div className="p-4 py-5 bg-gradientt rounded-4">
                    <section className="ps-dashboards" id="homepages">
                        <div className="row justify-content-between ">
                            <div>
                                <form onSubmit={handleSubmit} className="therapist-profile-form">
                                    <div className="row  mb-5">
                                        {/* Profile Image */}
                                        <div className="col-md-4 px-4 d-flex ">
                                            <div >
                                                <div className="input-field ">
                                                    <label htmlFor="profile_image" className='label'>
                                                        <input type="file" id="profile_image"
                                                            onChange={handleProfileImage}
                                                            accept="image/*"
                                                            placeholder="Profile Image" className='pb-2 ' />
                                                        <span>Profile Image</span>
                                                    </label>
                                                </div>
                                                {
                                                    errors.profile_image &&
                                                    <span className='badge text-danger span-error'>{errors.profile_image}</span>
                                                }
                                            </div>
                                            <img src={profile_image_link || user_icon} alt="" className="cust-image  ms-md-5 rounded border-secondary border border-2 p-1 mt-4" />
                                        </div>

                                        <div className="col-md-4 px-4 d-flex ">
                                            <div >
                                                <div className="input-field ">
                                                    <label htmlFor="Licence" className='label'>
                                                        <input type="file" id="Licence"
                                                            onChange={handleLicenceChange}
                                                            accept="image/*"
                                                            placeholder="Profile Image" className='pb-2 ' />
                                                        <span>Licence Image </span>
                                                    </label>
                                                </div>
                                                {
                                                    errors.website_image &&
                                                    <span className='badge text-danger span-error'>{errors.website_image}</span>
                                                }
                                            </div>
                                            <img src={website_image_link} alt="" className="cust-image-licence ms-md-5
                                            border-secondary border border-2 p-1 mt-4" />
                                        </div>
                                        <div className="col-md-4 px-4 d-flex ">
                                            <div >
                                                <div className="input-field ">
                                                    <label htmlFor="Licence" className='label'>
                                                        <input type="file" id="Licence"
                                                            onChange={handleCertificateChange}
                                                            accept="image/*"
                                                            placeholder="Profile Image" className='pb-2 ' />
                                                        <span>Instructor Certificate</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <img src={CertificateLink} alt="" className="cust-image-licence ms-md-5
                                            border-secondary border border-2 p-1 mt-4" />
                                        </div>
                                    </div>


                                    <div className="row">

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="name" className='label'>
                                                    <input type="text" id="name" placeholder="Name"
                                                        value={name}
                                                        onKeyPress={(e) => {
                                                            if (/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                    <span>Full Name  <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.name && <span className='badge text-danger span-error'>{errors.name}</span>
                                            }

                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label for="gender" className='label'>
                                                    <select id="gender"
                                                        value={gender}
                                                        onChange={(e) => setGender(e.target.value)}
                                                    >
                                                        <option value=""> Select Gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        {/* <option value="Other">Other</option> */}
                                                    </select>
                                                    <span>Gender <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.gender && <span className='badge text-danger span-error'>{errors.gender}</span>
                                            }
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="email" className='label'>
                                                    <input type="text" id="email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        placeholder="Email" />
                                                    <span>Email  <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.email && <span className='badge text-danger span-error'>{errors.email}</span>
                                            }
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="phone" className='label'>
                                                    <input type="text" id="phone"
                                                        value={phone}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={handlechange}
                                                        placeholder="Phone Number" />
                                                    <span>Phone Number  <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.phone && <span className='badge text-danger span-error'>{errors.phone}</span>
                                            }
                                        </div>


                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="years" className='label'>
                                                    <input type="text" id="years"
                                                        value={exp_years}
                                                        onChange={(e) => setexp_years(e.target.value)}
                                                        placeholder="Years of experience" />
                                                    <span>Years of experience  <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.exp_years && <span className='badge text-danger span-error'>{errors.exp_years}</span>
                                            }
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="location" className='label'>
                                                    <input type="text" id="location"
                                                        value={location}
                                                        onChange={(e) => setlocation(e.target.value)}
                                                        placeholder="Location" />
                                                    <span>Location <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {
                                                errors.location && <span className='badge text-danger span-error'>{errors.location}</span>
                                            }
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="emer1" className='label mb-3'>
                                                    <input type={ShowPassword ? "text" : "password"} id="emer1"
                                                        value={oldpassword}
                                                        onChange={(e) => setOldpassword(e.target.value)}
                                                        placeholder="Postal Code" />
                                                    <span>Old Password</span>
                                                </label>
                                            </div>
                                            {
                                                errors.oldpassword && <span className='badge text-danger span-error'>{errors.oldpassword}</span>
                                            }
                                            <div>
                                                <input type="checkbox"
                                                    className='form-check-input ms-3'
                                                    onChange={(e) => setshowpassword(e.target.checked)}
                                                    id='show_pwd' />
                                                <label htmlFor="show_pwd" className='mb-0 ms-2'>Show Password</label>
                                            </div>
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="emer" className='label'>
                                                    <input type={ShowPassword ? "text" : "password"} id="emer"
                                                        value={newpassword}
                                                        onChange={(e) => setnewpassword(e.target.value)}
                                                        placeholder="Postal Code" />
                                                    <span>New Password</span>
                                                </label>
                                            </div>
                                            {
                                                errors.newpassword && <span className='badge text-danger span-error'>{errors.newpassword}</span>
                                            }
                                        </div>

                                        <div className="col-12 px-4 mt-4 ">
                                            <label htmlFor="" className='text-green ps-3 mb-1'>Description experience and expertise (this will be shown to clients) <i className='text-danger'>*</i></label>
                                            <textarea
                                                value={description}
                                                rows={10}
                                                onChange={(e) => setDescription(e.target.value)}
                                                placeholder="Describe here.."
                                                className=' text-area-input p-3'
                                            >

                                            </textarea>

                                            {
                                                errors.description && <span className='badge text-danger  '>{errors.description}</span>
                                            }
                                        </div>

                                        <div className="col-12 text-center mt-5">
                                            <button type="button" onClick={() => navigate(-1)}
                                                className="button btn-black text-white me-4">
                                                <i className='icon-arrow-left me-3 fs-5'></i>
                                                back</button>
                                            <button type="submit" className="btn-green button" disabled={loading}>
                                                <i className={`bi bi-${loading ? 'arrow-repeat rotation me-3' : 'save'} me-2`}> </i>
                                                Save</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </ContainerDashboard>
        </>
    )
}

export default Profile